import { useRequest } from 'ahooks'

import { DEFAULT_OTP_RETRY_TIMER } from '$constants'

import { toast } from '$app/utilities'

import useSignal from '$actions/useSignal'
import useTimer from '$actions/useTimer'

import api from '$model/api'
import { errorMessageResolver } from '$services/api/common'

export const useEmailVerifyRequest = () => {
  const otpTimer = useTimer(DEFAULT_OTP_RETRY_TIMER)

  const {
    auth: { emailVerificationRequest }
  } = useSignal(api)
  const { runAsync, cancel, loading } = useRequest(emailVerificationRequest, {
    manual: true
  })

  const request = async () => {
    cancel()

    await toast
      .promise(runAsync(), {
        error: errorMessageResolver,
        loading: 'Requesting verify email..',
        success: 'Requested verify email!'
      })
      .unwrap()
      .then(() => {
        otpTimer.reset()
      })
  }

  return {
    loading,
    request,
    disabled: otpTimer.active,
    otpTimer
  }
}

export default useEmailVerifyRequest
